import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import styles from "./css/Footer.module.css";
import Button from "../ui/Button";
import SocialLinks from "./SocialLinks";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <Container>
        <Row className="align-items-start">
          {/* Left */}
          <Col md={6}>
            <div className={styles.footerLogo}>
              <img src="/binaxpay.png" alt="Binaxpay" className={styles.footerLogoImage} />
            </div>
            <div className={styles.footerDescription}>
              The most advanced cryptocurrency payment gateway for modern
              businesses. Secure, fast, and cost-effective solutions for the
              digital economy.
            </div>
            <SocialLinks className="mt-3" />
          </Col>

          {/* Right */}
          <Col md={6} className="mt-5 mt-md-0 text-md-end">
            <div className={styles.footerSubscribeTitle}>
              Subscribe to Our Newsletter
            </div>
            <div className={styles.subscribeWrapper}>
              <input
                type="email"
                className={styles.subscribeInput}
                placeholder="Your email address"
              />
              <Button text="Subscribe" className={styles.subscribeButton} />
            </div>
          </Col>
        </Row>

        <div className={styles.footerBottom}>
          © 2025-2026 Binaxpay. All rights reserved. Wallet services and other virtual asset services provided by Hodltech OÜ or its partners.
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
